module.exports = __webpack_public_path__ + "img/07d38c7684fd0b9529df45830dfb8d92.svg";